var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.278.368a.5.5 0 00-.643.766l16.087 13.498a.5.5 0 10.643-.766L1.278.368zM2 10.774v-7.19l9.948 8.347h-8.79A1.159 1.159 0 012 10.774zm11.918-7.617v6.511L4.779 2h7.981c.64 0 1.157.518 1.158 1.157zm4.749 7.566L14.689 8.55V5.405l3.978-2.171v7.489z",
    fill: "current"
  })));
}
export default SvgVideoOff;